/**
 * 判断一个数字是否在灰度范围内
 * @param mid - 要检查的数字
 * @param rate - 灰度比例
 * @returns 如果数字在灰度范围内，返回 true；否则，返回 false
 * @throws 如果 rate 不在 0 到 1 之间，抛出一个错误
 */
// buvid简单的灰度逻辑
function isGrayBuvid(buvid, rate) {
    if (typeof rate === 'string') {
        rate = parseFloat(rate);
    }
    if (rate < 0 || rate > 1) {
        throw new Error('Rate must be between 0 and 1');
    }
    const userNum = parseInt(buvid === null || buvid === void 0 ? void 0 : buvid.substring(0, 2), 16);
    const res = userNum > 256 * rate;
    return res;
}

export { isGrayBuvid };
